import { configureStore } from "@reduxjs/toolkit";
import LayoutSlice from "./Reducers/Layout";
import AppSidebar from "./Reducers/Messenger/AppSidebar";
import authReducer from "./Reducers/AuthReducer";
import MainSidebarSlice from "./Reducers/Messenger/MainSidebar";
import ChatReducer from "./Reducers/Messenger/Chat";
import MessengerSlice from "./Reducers/Messenger/Messenger";
import TemplateCustomizerReducers from "./Reducers/TemplateCustomizerReducers";

export const store = configureStore({
  reducer: {
    layout: LayoutSlice,
    appSidebar: AppSidebar,
    auth: authReducer,
    mainSidebar: MainSidebarSlice,
    chat: ChatReducer,
    messenger: MessengerSlice,
    templateCustomizer: TemplateCustomizerReducers,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
